// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Timeline */
.timeline {
  margin-top: 14px;
  border-left: 2px solid #e5e7eb;
  padding-left: 17px;
  margin-left: 9px;
}

.timeline-item {
  position: relative;
  padding: 12px;
  margin-bottom: 24px;
  background: #f1f5ff;
  border-radius: 4px;
}

.timeline-item::before {
  content: "";
  position: absolute;
  left: -28px;
  top: 0px;
  width: 20px;
  height: 20px;
  border-radius: 50%;
  background: currentColor;
  border: 3px solid white;
}

.red {
  color: #d71920;
}
.blue {
  color: #1769e0;
}
.green {
  color: #00a875;
}

.resolve-form label {
  display: block;
  color: #333;
  margin: 8px 0 5px;
  font-weight: 600;
  padding: 16px 40px;
  border-radius: 1px;
}

.upload-box {
  border: 1px dashed #ccc;
  background: white;
  display: flex !important;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  color: #45556d;
  cursor: pointer;
  margin-top: 8px;
  padding: "16px 40px";
}

.upload-box svg {
  font-size: 22px;
}

.upload-box small {
  font-weight: 400;
  font-size: 8px;
}

.upload-preview {
  position: relative;
  width: 20%;
  height: 20%;
}

.upload-preview img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.remove-image {
  position: absolute;
  top: 4px;
  right: 4px;
  width: 22px;
  height: 22px;
  border: none;
  border-radius: 50%;
  background: #fff;
  color: #d71920;
  font-size: 18px;
  line-height: 18px;
  cursor: pointer;
  z-index: 2;
}

.remove-image:hover {
  background: #f5f5f5;
}

.upload-loader {
  position: absolute;
  inset: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  background: rgba(255, 255, 255, 0.7);
  font-size: 11px;
  font-weight: 500;
}

textarea {
  width: 100%;
  height: 65px;
  resize: none;
  box-sizing: border-box;
  border: 1px solid #ddd;
  border-radius: 5px;
  padding: 9px;
  font-size: 11px;
}
`, "",{"version":3,"sources":["webpack://./src/components/LandingPages/ResolveInstallation.css"],"names":[],"mappings":"AAAA,aAAa;AACb;EACE,gBAAgB;EAChB,8BAA8B;EAC9B,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,WAAW;EACX,QAAQ;EACR,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,wBAAwB;EACxB,uBAAuB;AACzB;;AAEA;EACE,cAAc;AAChB;AACA;EACE,cAAc;AAChB;AACA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,WAAW;EACX,iBAAiB;EACjB,gBAAgB;EAChB,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,uBAAuB;EACvB,iBAAiB;EACjB,wBAAwB;EACxB,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;EACd,eAAe;EACf,eAAe;EACf,oBAAoB;AACtB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,WAAW;AACb;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,UAAU;EACV,WAAW;EACX,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;EACd,eAAe;EACf,iBAAiB;EACjB,eAAe;EACf,UAAU;AACZ;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,oCAAoC;EACpC,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,YAAY;EACZ,sBAAsB;EACtB,sBAAsB;EACtB,kBAAkB;EAClB,YAAY;EACZ,eAAe;AACjB","sourcesContent":["/* Timeline */\n.timeline {\n  margin-top: 14px;\n  border-left: 2px solid #e5e7eb;\n  padding-left: 17px;\n  margin-left: 9px;\n}\n\n.timeline-item {\n  position: relative;\n  padding: 12px;\n  margin-bottom: 24px;\n  background: #f1f5ff;\n  border-radius: 4px;\n}\n\n.timeline-item::before {\n  content: \"\";\n  position: absolute;\n  left: -28px;\n  top: 0px;\n  width: 20px;\n  height: 20px;\n  border-radius: 50%;\n  background: currentColor;\n  border: 3px solid white;\n}\n\n.red {\n  color: #d71920;\n}\n.blue {\n  color: #1769e0;\n}\n.green {\n  color: #00a875;\n}\n\n.resolve-form label {\n  display: block;\n  color: #333;\n  margin: 8px 0 5px;\n  font-weight: 600;\n  padding: 16px 40px;\n  border-radius: 1px;\n}\n\n.upload-box {\n  border: 1px dashed #ccc;\n  background: white;\n  display: flex !important;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  color: #45556d;\n  cursor: pointer;\n  margin-top: 8px;\n  padding: \"16px 40px\";\n}\n\n.upload-box svg {\n  font-size: 22px;\n}\n\n.upload-box small {\n  font-weight: 400;\n  font-size: 8px;\n}\n\n.upload-preview {\n  position: relative;\n  width: 20%;\n  height: 20%;\n}\n\n.upload-preview img {\n  width: 100%;\n  height: 100%;\n  object-fit: cover;\n}\n\n.remove-image {\n  position: absolute;\n  top: 4px;\n  right: 4px;\n  width: 22px;\n  height: 22px;\n  border: none;\n  border-radius: 50%;\n  background: #fff;\n  color: #d71920;\n  font-size: 18px;\n  line-height: 18px;\n  cursor: pointer;\n  z-index: 2;\n}\n\n.remove-image:hover {\n  background: #f5f5f5;\n}\n\n.upload-loader {\n  position: absolute;\n  inset: 0;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  background: rgba(255, 255, 255, 0.7);\n  font-size: 11px;\n  font-weight: 500;\n}\n\ntextarea {\n  width: 100%;\n  height: 65px;\n  resize: none;\n  box-sizing: border-box;\n  border: 1px solid #ddd;\n  border-radius: 5px;\n  padding: 9px;\n  font-size: 11px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
